module.exports = __webpack_public_path__ + "static/media/woman.ab2a8e79.png";